var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkMobileMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 5,
  viewBox: "0 0 19 5",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.25 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m7 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m7 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
})));
export default SvgVkMobileMore;